export const updateColors = (
    newPrimaryBgColor,
    newPrimaryColor,
    newSecondaryBgColor,
    newSecondaryColor,
    newExtraDetailsColor,
    newSecondaryExtraDetailsColor,
  ) => {
    document.documentElement.style.setProperty(
      '--primary-bgcolor',
      newPrimaryBgColor,
    );
    document.documentElement.style.setProperty(
      '--primary-color',
      newPrimaryColor,
    );
    document.documentElement.style.setProperty(
      '--secondary-bgcolor',
      newSecondaryBgColor,
    );
    document.documentElement.style.setProperty(
      '--secondary-color',
      newSecondaryColor,
    );
    document.documentElement.style.setProperty(
      '--extra-details-color',
      newExtraDetailsColor,
    );
    document.documentElement.style.setProperty(
      '--secondary-extra-details-color',
      newSecondaryExtraDetailsColor,
    );
  };